export default "__VITE_ASSET__B2eL0PmI__"